import { inject, injectable } from 'inversify';
import { NativeMessages } from 'src/native-messages';
import { Platform } from 'src/environment';
import type { NativeBridge } from '../utilities/native-bridge.utility';

import { TYPES } from '../di/types';

export interface TopRightButtonConfig {
  text: string;
}

export interface NativeUiService {
  setTitle(title: string);
  showTopRightButton(config: TopRightButtonConfig): void;
  hideTopRightButton(): void;
}

@injectable()
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class NativeUiServiceImpl implements NativeUiService {
  constructor(
    @inject(TYPES.NativeBridge) private readonly nativeBridge: NativeBridge,
    @inject(TYPES.AppConfig) private readonly appConfig: AppConfig,
  ) {}

  public setTitle(title: string) {
    this.runNativeHandler(() =>
      this.nativeBridge.toNative(NativeMessages.SET_TITLE, { title }),
    );
  }

  public showTopRightButton(config: TopRightButtonConfig): void {
    this.runNativeHandler(() =>
      this.nativeBridge.toNative(NativeMessages.SET_TOP_RIGHT_BUTTON, {
        config,
      }),
    );
  }

  public hideTopRightButton(): void {
    this.runNativeHandler(() =>
      this.nativeBridge.toNative(NativeMessages.SET_TOP_RIGHT_BUTTON, null),
    );
  }

  private runNativeHandler(handler: () => void): void {
    if (this.appConfig.platform !== Platform.WEB) {
      handler();
    }
  }
}
